"use strict";

var _interopRequireDefault = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _interopRequireWildcard2 = _interopRequireDefault(require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/@babel/runtime/helpers/interopRequireWildcard.js"));
var _index = _interopRequireDefault(require("@/layout/index.vue"));
const leadsNotificationsRouter = {
  path: '/leads-notifications',
  component: _index.default,
  redirect: 'noredirect',
  name: 'Notifications',
  meta: {
    title: 'notifications.title',
    icon: 'guide',
    roles: ['System Admin', 'Super Admin', 'Sales Coordinator']
  },
  children: [{
    path: 'list',
    component: () => Promise.resolve().then(() => (0, _interopRequireWildcard2.default)(require(/* webpackChunkName: "admins-list" */'@/views/leads-notifications/list.vue'))),
    name: 'Notifications',
    meta: {
      title: 'notifications.title',
      noCache: true,
      icon: 'guide'
    }
  }]
};
var _default = exports.default = leadsNotificationsRouter;